import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Iframe from 'react-iframe';
import ImageButton from 'components/shared/button/ImageButton';
import closeSvg from 'images/close.svg';
import './SigningModal.css';

class SigningModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    url: PropTypes.string,
    title: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired,
  };

  render() {
    return (
      <Modal className="signing-modal" show={this.props.show}>
        <Modal.Header>
          <div className="body-bold">{this.props.title}</div>
          <ImageButton
            alt="close"
            src={closeSvg}
            onClick={this.props.handleClose}
          />
        </Modal.Header>
        <Modal.Body>
          {this.props.url && (
            <Iframe
              url={this.props.url}
              className="signing-iframe"
              width="100%"
              height="100%"
              display="initial"
              position="relative"
              allowFullScreen
            />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default SigningModal;



// WEBPACK FOOTER //
// ./src/components/shared/modal/SigningModal.js